module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/134.8d5555dd.png";